import React, { useState, useEffect } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Bell } from "lucide-react";

const StickyBottomBar = ({ onNotifyClick }) => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div 
      className="md:hidden fixed left-0 right-0 bottom-0 z-[9999]"
    >
      {/* Simple white background - just enough to cover */}
      <div 
        className="absolute inset-0 bg-white"
        style={{ 
          bottom: '-100px', // extend below for iOS safe area
          boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        }}
      />
      
      {/* Button with minimal padding */}
      <div 
        className="relative px-4 py-3"
        style={{
          paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
        }}
      >
        <button
          onClick={onNotifyClick}
          className="w-full bg-gradient-to-r from-[#05ce78] to-[#0f9f5f] text-white font-bold py-4 rounded-2xl text-lg shadow-lg active:scale-[0.98] transition-transform flex items-center justify-center gap-2"
          data-testid="sticky-kickstarter-btn"
        >
          <Bell className="w-5 h-5" />
          {language === 'fr' ? 'Être notifié du lancement' : 'Get notified at launch'}
        </button>
      </div>
    </div>
  );
};

export default StickyBottomBar;
